module.exports = __webpack_public_path__ + "static/media/transaction.24e355f7.svg";